import { logger } from '@automata/utils';
import type { Driver } from '@automata/wfb-api';
import { ParameterDefinition } from '@automata/wfb-api/src/apis/wfbApiSchemas';

import type { TaskProperties } from '../../types';
import { getTaskTimeEstimateTypeAndValue } from '../../utils';
import type { TimeEstimateValuesByTaskId } from '../shared/types';

export default function getTimeEstimateValues(
  driverForTaskByTaskId: Record<string, Driver>,
  taskPropertiesById: Record<string, TaskProperties>,
  parameterDefinitions: ParameterDefinition[]
): TimeEstimateValuesByTaskId {
  return Object.entries(driverForTaskByTaskId).reduce<{
    [taskId: string]: number | null;
  }>((acc, [taskId, driver]) => {
    const taskProperties = taskPropertiesById[taskId];
    if (taskProperties === undefined) {
      logger.warn(`missing properties for task ${taskId}`);
      return acc;
    }
    const { taskType, userTimeEstimate } = taskProperties;
    const action = driver.actions[taskType];
    if (action === undefined) {
      logger.warn(
        `missing action ${taskType} on driver ${driver.name} ${driver.version}`
      );
      return acc;
    }
    const timeEstimate = getTaskTimeEstimateTypeAndValue({
      action,
      parameters: {
        ...taskProperties.taskParameters,
        ...taskProperties.taskAppliedParameters,
      },
      userTimeEstimate,
      parameterDefinitions,
    });

    return { ...acc, [taskId]: timeEstimate.value };
  }, {});
}
